import React from 'react'
import { DragHandle, SortableItem } from './SortableItem'
import './sortable-list.scss'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { Flex } from 'antd'

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
}

const SortableList = ({ items, header, onChange, onChangeWithCustomMovingLogic, renderItem }) => {
    function onDragEnd(result) {
        if (!result.destination) return
        if (result.destination.index === result.source.index) return

        if (onChangeWithCustomMovingLogic) {
            onChangeWithCustomMovingLogic(result.source.index, result.destination.index)
            return
        }

        onChange(reorder(items, result.source.index, result.destination.index))
    }

    return (
        <Flex vertical>
            {header}
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId='list'>
                    {provided => (
                        <ul
                            className='SortableList'
                            role='application'
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {items.map((item, index) => (
                                <React.Fragment key={Object.hasOwn(item, 'id') ? item.id : item.key}>
                                    {renderItem(item, index)}
                                </React.Fragment>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        </Flex>
    )
}

SortableList.Item = SortableItem
SortableList.DragHandle = DragHandle

export default SortableList
